const CONNECTOR_MODULE_PREFIX = 'connector:';

export const CONNECTOR_HOME_SCREEN = 'connector:/';
export const CONNECTOR_HOME_GUIDANCE_SCREEN = 'connector:/#getting-started';
export const CONNECTOR_HOME_ADD_SCREEN = 'connector:/#add-connector';
export const CONNECTOR_NEW_SCREEN = 'connector:/connectors/new';
export const CONNECTOR_WELCOME_SCREEN = 'connector:/welcome';
export const CONNECTOR_ADD_API_SCREEN = 'connector:/connectors/add-api';
export const CONNECTOR_ADD_API_PROCESS_SCREEN = 'connector:/connectors/add-api#process-api-spec';
export const CONNECTOR_ADD_API_REVIEW_SCREEN = 'connector:/connectors/add-api/review';
export const CONNECTOR_ADD_API_EDIT_SCREEN = 'connector:/connectors/add-api/review#edit-action';
export const CONNECTOR_ADD_API_DELETE_SCREEN = 'connector:/connectors/add-api/review#delete-action';
export const CONNECTOR_AUTH_SCREEN = 'connector:/connectors/authentication';
export const CONNECTOR_AUTH_OAUTH_SCREEN = 'connector:/connectors/authentication#oauth2';
export const CONNECTOR_COMPLETED_SCREEN = 'connector:/connectors/completed';
export const SPECS_ACTIONS_SCREEN = 'connector:/specs/actions';
export const SPEC_ACTION_SCREEN = 'connector:/specs/action';
export const SPECS_ACTIONS_ADD_API_SCREEN = 'connector:/specs/actions#add-api';
export const SPECS_ACTIONS_EDIT_ACTION_SCREEN = 'connector:/specs/actions#edit-action';
export const SPECS_ACTIONS_DELETE_ACTION_SCREEN = 'connector:/specs/actions#delete-action';
export const SPECS_ACTIONS_EDIT_SYSTEM_SCREEN = 'connector:/specs/actions#edit-system';
export const SPECS_ACTIONS_DELETE_SYSTEM_SCREEN = 'connector:/specs/actions#delete-system';
export const SPECS_ACTIONS_AUTH_TAB_SCREEN = 'connector:/specs/actions#tab-authentication';
export const SPECS_ACTIONS_AUTH_EDIT_SCREEN = 'connector:/specs/actions#tab-authentication#edit';
export const SPECS_ACTIONS_AUTH_OAUTH_SCREEN = 'connector:/specs/actions#tab-authentication#oauth2';
export const SPECS_ACTIONS_SUMMARY_SCREEN = 'connector:/specs/actions#generate-summary';
export const SPECS_ACTIONS_NEW_SCREEN = 'connector:/specs/actions/new';
export const SPECS_ACTIONS_NEW_PROCESS_SCREEN = 'connector:/specs/actions/new#process-api-spec';
export const SPECS_ACTIONS_NEW_REVIEW_SCREEN = 'connector:/specs/actions/new/review';
export const SPEC_ACTION_EDIT_SCREEN = 'connector:/specs/action#enter-edit-mode';
export const SPEC_ACTION_DELETE_SCREEN = 'connector:/specs/action#delete';
export const PLAYGROUND_TEST_SCREEN = 'connector:/specs/actions#playground-test';

export const MCP_HOME_SCREEN = 'connector:/mcp';
export const MCP_HOME_ADD_SCREEN = 'connector:/#add-mcp';
export const MCP_ADD_SCREEN = 'connector:/mcp/add';
export const MCP_MANAGE_SCREEN = 'connector:/mcp/manage';
export const MCP_MANAGE_EDIT_SCREEN = 'connector:/mcp/manage#edit';
export const MCP_MANAGE_STATUS_SCREEN = 'connector:/mcp/manage#status';
export const MCP_MANAGE_DELETE_SCREEN = 'connector:/mcp/manage#delete';
export const MCP_MANAGE_PLAYGROUND_SCREEN = 'connector:/mcp/manage#playground';

export const CONNECTOR_SYSTEM_VIEW_FEATURE = 'feature:app:ai:connector:system:view';
export const CONNECTOR_SYSTEM_CREATE_FEATURE = 'feature:app:ai:connector:system:create';
export const CONNECTOR_SYSTEM_UPDATE_FEATURE = 'feature:app:ai:connector:system:update';
export const CONNECTOR_SYSTEM_DELETE_FEATURE = 'feature:app:ai:connector:system:delete';
export const CONNECTOR_ACTION_VIEW_FEATURE = 'feature:app:ai:connector:action:view';
export const CONNECTOR_ACTION_UPDATE_FEATURE = 'feature:app:ai:connector:action:update';
export const CONNECTOR_ACTION_DELETE_FEATURE = 'feature:app:ai:connector:action:delete';
export const CONNECTOR_API_IMPORT_FEATURE = 'feature:app:ai:connector:api:import';
export const CONNECTOR_CREDENTIAL_VIEW_FEATURE = 'feature:app:ai:connector:credential:view';
export const CONNECTOR_CREDENTIAL_MANAGE_FEATURE = 'feature:app:ai:connector:credential:manage';
export const CONNECTOR_PLAYGROUND_FEATURE = 'feature:app:ai:connector:playground:test';
export const CONNECTOR_SUMMARY_FEATURE = 'feature:app:ai:connector:summary:manage';
export const CONNECTOR_MCP_VIEW_FEATURE = 'feature:app:ai:connector:mcp:view';
export const CONNECTOR_MCP_CREATE_FEATURE = 'feature:app:ai:connector:mcp:create';
export const CONNECTOR_MCP_UPDATE_FEATURE = 'feature:app:ai:connector:mcp:update';
export const CONNECTOR_MCP_STATUS_FEATURE = 'feature:app:ai:connector:mcp:status:manage';
export const CONNECTOR_MCP_DELETE_FEATURE = 'feature:app:ai:connector:mcp:delete';
export const CONNECTOR_MCP_PLAYGROUND_FEATURE = 'feature:app:ai:connector:mcp:playground:test';
export const OTEN_COPILOT_ACCESS_FEATURE = 'feature:app:ai:copilot:access';

const ALL_CONNECTOR_FEATURES = new Set([
  CONNECTOR_SYSTEM_VIEW_FEATURE,
  CONNECTOR_SYSTEM_CREATE_FEATURE,
  CONNECTOR_SYSTEM_UPDATE_FEATURE,
  CONNECTOR_SYSTEM_DELETE_FEATURE,
  CONNECTOR_ACTION_VIEW_FEATURE,
  CONNECTOR_ACTION_UPDATE_FEATURE,
  CONNECTOR_ACTION_DELETE_FEATURE,
  CONNECTOR_API_IMPORT_FEATURE,
  CONNECTOR_CREDENTIAL_VIEW_FEATURE,
  CONNECTOR_CREDENTIAL_MANAGE_FEATURE,
  CONNECTOR_PLAYGROUND_FEATURE,
  CONNECTOR_SUMMARY_FEATURE,
  CONNECTOR_MCP_VIEW_FEATURE,
  CONNECTOR_MCP_CREATE_FEATURE,
  CONNECTOR_MCP_UPDATE_FEATURE,
  CONNECTOR_MCP_STATUS_FEATURE,
  CONNECTOR_MCP_DELETE_FEATURE,
  CONNECTOR_MCP_PLAYGROUND_FEATURE,
]);

const SYSTEM_CONNECTOR_FEATURES = new Set([
  CONNECTOR_SYSTEM_VIEW_FEATURE,
  CONNECTOR_SYSTEM_CREATE_FEATURE,
  CONNECTOR_SYSTEM_UPDATE_FEATURE,
  CONNECTOR_SYSTEM_DELETE_FEATURE,
  CONNECTOR_ACTION_VIEW_FEATURE,
  CONNECTOR_ACTION_UPDATE_FEATURE,
  CONNECTOR_ACTION_DELETE_FEATURE,
  CONNECTOR_API_IMPORT_FEATURE,
  CONNECTOR_CREDENTIAL_VIEW_FEATURE,
  CONNECTOR_CREDENTIAL_MANAGE_FEATURE,
  CONNECTOR_PLAYGROUND_FEATURE,
  CONNECTOR_SUMMARY_FEATURE,
]);

function normalizePermissionCode(value: string): string {
  return value.trim().toLowerCase();
}

function normalizePermissionCodes(values: string[] | null | undefined): Set<string> {
  if (!values?.length) return new Set<string>();
  return new Set(values.map(value => normalizePermissionCode(value ?? '')).filter(Boolean));
}

function userScreensInclude(userScreens: Set<string>, target: string): boolean {
  if (userScreens.has(target)) return true;
  for (const entry of userScreens) {
    if (!entry.endsWith('/*')) continue;
    const prefix = entry.slice(0, -2);
    if (prefix && (target === prefix || target.startsWith(`${prefix}/`))) {
      return true;
    }
  }
  return false;
}

export function canonicalizeMcpScreen(screen: string): string {
  const normalized = normalizePermissionCode(screen);
  if (!normalized) return '';
  const rawPath = normalized.startsWith(CONNECTOR_MODULE_PREFIX)
    ? normalized.slice(CONNECTOR_MODULE_PREFIX.length)
    : normalized;
  const withSlash = rawPath.startsWith('/') ? rawPath : `/${rawPath}`;
  const path = withSlash.length > 1 && withSlash.endsWith('/') ? withSlash.slice(0, -1) : withSlash;

  if (path === '/mcp') {
    return MCP_HOME_SCREEN;
  }
  if (path === '/mcp/add') {
    return MCP_ADD_SCREEN;
  }
  if (path === '/mcp/manage#edit') {
    return MCP_MANAGE_EDIT_SCREEN;
  }
  if (path === '/mcp/manage#status') {
    return MCP_MANAGE_STATUS_SCREEN;
  }
  if (path === '/mcp/manage#delete') {
    return MCP_MANAGE_DELETE_SCREEN;
  }
  if (path === '/mcp/manage#playground') {
    return MCP_MANAGE_PLAYGROUND_SCREEN;
  }
  if (path.startsWith('/mcp/')) {
    return MCP_MANAGE_SCREEN;
  }
  return normalized;
}

export function normalizeConnectorScreens(screens: string[] | null | undefined): Set<string> {
  return normalizePermissionCodes(screens);
}

export function normalizeConnectorFeatures(features: string[] | null | undefined): Set<string> {
  return normalizePermissionCodes(features);
}

export function hasOtenCopilotAccess(features: string[] | Set<string> | null | undefined): boolean {
  const normalizedFeatures =
    features instanceof Set ? features : normalizeConnectorFeatures(features);
  return normalizedFeatures.has(OTEN_COPILOT_ACCESS_FEATURE);
}

export function hasConnectorScreenAccess(
  screens: string[] | Set<string> | null | undefined,
  screen: string
): boolean {
  const normalizedScreens = screens instanceof Set ? screens : normalizeConnectorScreens(screens);
  const normalizedTarget = canonicalizeMcpScreen(screen);
  if (normalizedTarget.startsWith(CONNECTOR_MODULE_PREFIX)) {
    return userScreensInclude(normalizedScreens, normalizedTarget);
  }
  return false;
}

export function hasAnyConnectorScreenAccess(
  screens: string[] | Set<string> | null | undefined,
  targets: Iterable<string>
): boolean {
  const normalizedScreens = screens instanceof Set ? screens : normalizeConnectorScreens(screens);
  for (const target of targets) {
    if (hasConnectorScreenAccess(normalizedScreens, target)) return true;
  }
  return false;
}

function hasFeature(features: Set<string>, feature: string): boolean {
  return features.has(feature);
}

function hasAnyFeature(features: Set<string>, targets: Iterable<string>): boolean {
  for (const target of targets) {
    if (features.has(target)) return true;
  }
  return false;
}

const SYSTEM_CREATE_SCREENS = new Set([
  CONNECTOR_HOME_GUIDANCE_SCREEN,
  CONNECTOR_HOME_ADD_SCREEN,
  CONNECTOR_NEW_SCREEN,
  CONNECTOR_WELCOME_SCREEN,
  CONNECTOR_ADD_API_SCREEN,
  CONNECTOR_ADD_API_PROCESS_SCREEN,
  CONNECTOR_ADD_API_REVIEW_SCREEN,
  CONNECTOR_ADD_API_EDIT_SCREEN,
  CONNECTOR_ADD_API_DELETE_SCREEN,
  CONNECTOR_COMPLETED_SCREEN,
]);
const API_IMPORT_SCREENS = new Set([
  SPECS_ACTIONS_ADD_API_SCREEN,
  SPECS_ACTIONS_NEW_SCREEN,
  SPECS_ACTIONS_NEW_PROCESS_SCREEN,
  SPECS_ACTIONS_NEW_REVIEW_SCREEN,
]);

export interface ConnectorCapabilities {
  canViewSystems: boolean;
  canCreateSystem: boolean;
  canUpdateSystem: boolean;
  canDeleteSystem: boolean;
  canViewActions: boolean;
  canUpdateAction: boolean;
  canDeleteAction: boolean;
  canImportApi: boolean;
  canViewCredentials: boolean;
  canManageCredentials: boolean;
  canManageStandaloneCredentials: boolean;
  canUseStandaloneOAuth: boolean;
  canManageEmbeddedCredentials: boolean;
  canUseEmbeddedOAuth: boolean;
  canUsePlayground: boolean;
  canManageSummary: boolean;
  canViewMcps: boolean;
  canCreateMcp: boolean;
  canUpdateMcp: boolean;
  canManageMcpStatus: boolean;
  canDeleteMcp: boolean;
  canUseMcpPlayground: boolean;
}

export function canAccessConnectorScreen(
  screensInput: string[] | Set<string> | null | undefined,
  featuresInput: string[] | Set<string> | null | undefined,
  targetInput: string
): boolean {
  const screens =
    screensInput instanceof Set ? screensInput : normalizeConnectorScreens(screensInput);
  const features =
    featuresInput instanceof Set ? featuresInput : normalizeConnectorFeatures(featuresInput);
  const target = canonicalizeMcpScreen(targetInput);

  if (!hasConnectorScreenAccess(screens, target)) return false;
  if (target === CONNECTOR_HOME_SCREEN || target === SPECS_ACTIONS_SCREEN) {
    return hasAnyFeature(features, ALL_CONNECTOR_FEATURES);
  }
  if (target === MCP_HOME_SCREEN || target === MCP_MANAGE_SCREEN) {
    return hasAnyFeature(features, [
      CONNECTOR_MCP_VIEW_FEATURE,
      CONNECTOR_MCP_CREATE_FEATURE,
      CONNECTOR_MCP_UPDATE_FEATURE,
      CONNECTOR_MCP_STATUS_FEATURE,
      CONNECTOR_MCP_DELETE_FEATURE,
      CONNECTOR_MCP_PLAYGROUND_FEATURE,
    ]);
  }
  if (target === MCP_HOME_ADD_SCREEN || target === MCP_ADD_SCREEN) {
    return hasFeature(features, CONNECTOR_MCP_CREATE_FEATURE);
  }
  if (target === MCP_MANAGE_EDIT_SCREEN) {
    return hasFeature(features, CONNECTOR_MCP_UPDATE_FEATURE);
  }
  if (target === MCP_MANAGE_STATUS_SCREEN) {
    return hasFeature(features, CONNECTOR_MCP_STATUS_FEATURE);
  }
  if (target === MCP_MANAGE_DELETE_SCREEN) {
    return hasFeature(features, CONNECTOR_MCP_DELETE_FEATURE);
  }
  if (target === MCP_MANAGE_PLAYGROUND_SCREEN) {
    return hasFeature(features, CONNECTOR_MCP_PLAYGROUND_FEATURE);
  }
  if (SYSTEM_CREATE_SCREENS.has(target)) {
    return hasFeature(features, CONNECTOR_SYSTEM_CREATE_FEATURE);
  }
  if (API_IMPORT_SCREENS.has(target)) {
    return hasFeature(features, CONNECTOR_API_IMPORT_FEATURE);
  }
  if (target === CONNECTOR_AUTH_SCREEN || target === CONNECTOR_AUTH_OAUTH_SCREEN) {
    return hasFeature(features, CONNECTOR_CREDENTIAL_MANAGE_FEATURE);
  }
  if (target === SPEC_ACTION_SCREEN) {
    return hasAnyFeature(features, [
      CONNECTOR_ACTION_VIEW_FEATURE,
      CONNECTOR_ACTION_UPDATE_FEATURE,
      CONNECTOR_ACTION_DELETE_FEATURE,
    ]);
  }
  if (target === SPECS_ACTIONS_EDIT_ACTION_SCREEN || target === SPEC_ACTION_EDIT_SCREEN) {
    return hasFeature(features, CONNECTOR_ACTION_UPDATE_FEATURE);
  }
  if (target === SPECS_ACTIONS_DELETE_ACTION_SCREEN || target === SPEC_ACTION_DELETE_SCREEN) {
    return hasFeature(features, CONNECTOR_ACTION_DELETE_FEATURE);
  }
  if (target === SPECS_ACTIONS_EDIT_SYSTEM_SCREEN) {
    return hasFeature(features, CONNECTOR_SYSTEM_UPDATE_FEATURE);
  }
  if (target === SPECS_ACTIONS_DELETE_SYSTEM_SCREEN) {
    return hasFeature(features, CONNECTOR_SYSTEM_DELETE_FEATURE);
  }
  if (target === SPECS_ACTIONS_AUTH_TAB_SCREEN) {
    return hasAnyFeature(features, [
      CONNECTOR_CREDENTIAL_VIEW_FEATURE,
      CONNECTOR_CREDENTIAL_MANAGE_FEATURE,
    ]);
  }
  if (target === SPECS_ACTIONS_AUTH_EDIT_SCREEN || target === SPECS_ACTIONS_AUTH_OAUTH_SCREEN) {
    return hasFeature(features, CONNECTOR_CREDENTIAL_MANAGE_FEATURE);
  }
  if (target === PLAYGROUND_TEST_SCREEN) {
    return hasFeature(features, CONNECTOR_PLAYGROUND_FEATURE);
  }
  if (target === SPECS_ACTIONS_SUMMARY_SCREEN) {
    return hasFeature(features, CONNECTOR_SUMMARY_FEATURE);
  }
  return false;
}

export function resolveConnectorCapabilities(
  screensInput: string[] | null | undefined,
  featuresInput: string[] | null | undefined
): ConnectorCapabilities {
  const screens = normalizeConnectorScreens(screensInput);
  const features = normalizeConnectorFeatures(featuresInput);
  const canAccess = (screen: string) => canAccessConnectorScreen(screens, features, screen);
  const canViewCredentials = canAccess(SPECS_ACTIONS_AUTH_TAB_SCREEN);
  const canManageStandaloneCredentials = canAccess(CONNECTOR_AUTH_SCREEN);
  const canManageEmbeddedCredentials =
    canViewCredentials && canAccess(SPECS_ACTIONS_AUTH_EDIT_SCREEN);
  const canUseStandaloneOAuth =
    canManageStandaloneCredentials && canAccess(CONNECTOR_AUTH_OAUTH_SCREEN);
  const canUseEmbeddedOAuth =
    canManageEmbeddedCredentials && canAccess(SPECS_ACTIONS_AUTH_OAUTH_SCREEN);

  return {
    canViewSystems:
      (hasConnectorScreenAccess(screens, CONNECTOR_HOME_SCREEN) ||
        hasConnectorScreenAccess(screens, SPECS_ACTIONS_SCREEN)) &&
      hasAnyFeature(features, SYSTEM_CONNECTOR_FEATURES),
    canCreateSystem:
      hasAnyConnectorScreenAccess(screens, SYSTEM_CREATE_SCREENS) &&
      hasFeature(features, CONNECTOR_SYSTEM_CREATE_FEATURE),
    canUpdateSystem: canAccess(SPECS_ACTIONS_EDIT_SYSTEM_SCREEN),
    canDeleteSystem: canAccess(SPECS_ACTIONS_DELETE_SYSTEM_SCREEN),
    canViewActions:
      (canAccess(SPECS_ACTIONS_SCREEN) || canAccess(SPEC_ACTION_SCREEN)) &&
      hasAnyFeature(features, [
        CONNECTOR_ACTION_VIEW_FEATURE,
        CONNECTOR_ACTION_UPDATE_FEATURE,
        CONNECTOR_ACTION_DELETE_FEATURE,
      ]),
    canUpdateAction:
      canAccess(SPECS_ACTIONS_EDIT_ACTION_SCREEN) || canAccess(SPEC_ACTION_EDIT_SCREEN),
    canDeleteAction:
      canAccess(SPECS_ACTIONS_DELETE_ACTION_SCREEN) || canAccess(SPEC_ACTION_DELETE_SCREEN),
    canImportApi:
      hasAnyConnectorScreenAccess(screens, API_IMPORT_SCREENS) &&
      hasFeature(features, CONNECTOR_API_IMPORT_FEATURE),
    canViewCredentials,
    canManageCredentials: canManageStandaloneCredentials || canManageEmbeddedCredentials,
    canManageStandaloneCredentials,
    canUseStandaloneOAuth,
    canManageEmbeddedCredentials,
    canUseEmbeddedOAuth,
    canUsePlayground: canAccess(PLAYGROUND_TEST_SCREEN),
    canManageSummary: canAccess(SPECS_ACTIONS_SUMMARY_SCREEN),
    canViewMcps: canAccess(MCP_HOME_SCREEN),
    canCreateMcp: canAccess(MCP_HOME_ADD_SCREEN) || canAccess(MCP_ADD_SCREEN),
    canUpdateMcp: canAccess(MCP_MANAGE_EDIT_SCREEN),
    canManageMcpStatus: canAccess(MCP_MANAGE_STATUS_SCREEN),
    canDeleteMcp: canAccess(MCP_MANAGE_DELETE_SCREEN),
    canUseMcpPlayground: canAccess(MCP_MANAGE_PLAYGROUND_SCREEN),
  };
}

// ---------------------------------------------------------------------------
// Ref/template read-only helpers
// ---------------------------------------------------------------------------

interface SystemReadOnlyInput {
  read_only?: boolean;
  is_template?: boolean;
  is_owner?: boolean;
}

export function isReadOnlyRefSystem(system: SystemReadOnlyInput | null | undefined): boolean {
  if (!system) return false;
  if (typeof system.read_only === 'boolean') return system.read_only;
  return system.is_template === true && !system.is_owner;
}

export function refSystemAuthMode(
  system: (SystemReadOnlyInput & { has_shared_auth?: boolean }) | null | undefined
): 'shared' | 'own-input' | 'not-applicable' {
  if (!isReadOnlyRefSystem(system)) return 'not-applicable';
  return system!.has_shared_auth ? 'shared' : 'own-input';
}
